import { useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useTranslation } from "react-i18next";
import axios from "axios";

function LangSelector({ idiomas, langactual }) {
    const { i18n, t } = useTranslation();

    // Siempre almacenamos el código de idioma (es, en, fr...)
    const [langu, setLangu] = useState(langactual?.toLowerCase() || "");

    // Idioma -> País
    const langToCountry = {
        en: "US",
        cs: "CZ",
        es: "ES",
        fr: "FR",
        it: "IT",
        pt: "PT",
        ru: "RU",
        de: "DE",
        sv: "SE",
        ca: "CA",
        nl: "NL",
    };

    // País -> Idioma
    const countryToLang = {
        US: "en",
        CZ: "cs",
        ES: "es",
        FR: "fr",
        IT: "it",
        PT: "pt",
        RU: "ru",
        DE: "de",
        SE: "sv",
        CA: "ca",
        NL: "nl",
    };

    const countriesarr = idiomas.map((idioma) =>
        langToCountry[idioma.codigo] || idioma.codigo.toUpperCase()
    );

    const customLabelsarr = {};

    idiomas.forEach((idioma) => {
        const country =
            langToCountry[idioma.codigo] || idioma.codigo.toUpperCase();

        customLabelsarr[country] = idioma.nombre;
    });

    const getUserBrowserLanguage = () => {
        const lang = (langactual || window.navigator.language).toLowerCase();

        const idiomasSoportados = [
            "es",
            "en",
            "fr",
            "it",
            "pt",
            "ru",
            "de",
            "sv",
            "ca",
            "cs",
            "nl",
        ];

        const encontrado = idiomasSoportados.find((l) => lang.includes(l));

        return encontrado || "es";
    };

    const handleLangSelect = (countryCode) => {
        const currentLang = countryToLang[countryCode] || "es";

        i18n.changeLanguage(currentLang);
        setLangu(currentLang);

        const token = document
            .getElementById("meta_token")
            .getAttribute("content");

        axios
            .post(
                "/cambiaidioma",
                {
                    lang: currentLang,
                },
                {
                    headers: {
                        "content-type": "text/json",
                        "X-CSRF-TOKEN": token,
                    },
                }
            )
            .then(() => {
                window.location.reload();
            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        const userLang = getUserBrowserLanguage();

        i18n.changeLanguage(userLang);
        setLangu(userLang);
    }, []);

    return (
        <ReactFlagsSelect
            countries={countriesarr}
            customLabels={customLabelsarr}
            selected={langToCountry[langu] || langu.toUpperCase()}
            onSelect={handleLangSelect}
            placeholder={t("Seleccione_Idioma")}
        />
    );
}

export default LangSelector;
